<template>
  <!-- 区域管理 -->
  <div class="treeBigBox app-container">
    <!--树形结构-->
    <div class="treeBox">
      <h4>设备列表</h4>
      <ul>
        <li v-for="(item, index) in dataList" :key="item.id" style="line-height: 32px;cursor: pointer" :class="{active1:item.flag}" @click="lookFN(item.id,item.flag)">
          <i class="fa fa-video-camera" aria-hidden="true" /></i>&nbsp;&nbsp;{{ item.deviceName }}
        </li>
      </ul>
    </div>
    <div class="right">
        <div  :class="{playerBox:true,active:dqIndex==item.bianhao}" v-for="item in vadioArr" :key="item.bianhao"
        @click="xuanzhongFn(item.bianhao)" :ref="'playerRef'+item.bianhao">
          <div  style="width: 100%;height: 100%;" :id="'player'+item.bianhao"></div>
          <div class="tishiBox" v-if="!item.bfFlag">请选择监控点</div>
          <div class="delBox" @click="guanbiFN(item.bianhao)"  v-if="item.bfFlag"><i class="el-icon-close"></i></div>
        </div>
    </div>
  </div>
</template>

<script>
import { equipmentList, deviceList, getVideoUrl } from '@/api/video'
import EZUIKit from 'ezuikit-js'
export default {
  inject: ['reload'],

  data () {
    return {
      dataList: [],
      dqIndex: 1,
      vadioArr: [{ bianhao: 1, bfFlag: false }, { bianhao: 2, bfFlag: false }, { bianhao: 3, bfFlag: false }, { bianhao: 4, bfFlag: false }],
      tenantName: this.$route.query.name ? this.$route.query.name : localStorage.getItem('tenantName')

    }
  },
  created () {
    this.getListTree()
  },
  mounted () {

  },
  methods: {
    // 关闭
    guanbiFN (n) {
      let that = this
      if (that.vadioArr[n - 1].player) {
        that.vadioArr[n - 1].player.stop().then(r => {
          // 移除DOM元素（如果有）
          let container = document.getElementById('player' + n + '-wrap')
          while (container.firstChild) {
            container.removeChild(container.firstChild)
          }
          if (container) {
            container.innerHTML = ''
          }
          that.vadioArr[n - 1].player = null
          this.$set(this.vadioArr[n - 1], 'bfFlag', false)
          this.$set(this.vadioArr[n - 1], 'id', null)
          this.gengxinFN()
          this.$nextTick(() => {

          })
        })
      }
    },
    // 选择
    xuanzhongFn (n) {
      this.dqIndex = n
    },
    lookFN (id, flag) {
      let that = this
      if (flag) {
        this.$message({
          message: '当前设备已选择',
          type: 'warning'
        })
        return
      }
      this.$set(this.vadioArr[this.dqIndex - 1], 'id', id)
      this.gengxinFN()
      let h = this.$refs['playerRef' + this.dqIndex][0].offsetHeight
      let w = this.$refs['playerRef' + this.dqIndex][0].offsetWidth
      getVideoUrl({ id: id }).then(res => {
        if (this.vadioArr[this.dqIndex - 1].bfFlag) { // 如果原来有播放就清空之后再播放
          // this.vadioArr[this.dqIndex - 1].player.changePlayUrl({
          //   accessToken: res.token,
          //   url: res.url
          // }).then(() => {
          //   console.log('切换成功')
          // })
          that.vadioArr[this.dqIndex - 1].player.stop().then(r => {
            // 移除DOM元素（如果有）
            let container = document.getElementById('player' + this.dqIndex + '-wrap')
            while (container.firstChild) {
              container.removeChild(container.firstChild)
            }
            if (container) {
              container.innerHTML = ''
            }
            this.vadioArr[this.dqIndex - 1].player = new EZUIKit.EZUIKitPlayer({
              id: 'player' + this.dqIndex, // 视频容器ID
              accessToken: res.token,
              url: res.url,
              template: 'security',
              height: h,
              width: w,
              handleError: (err) => {
                if (err.type === 'handleRunTimeInfoError' && err.data.nErrorCode === 5) {
                  // 加密设备密码错误
                }
              }
            })
            if (this.dqIndex < 4) {
              this.dqIndex++
            } else {
              this.dqIndex = 1
            }
          })
        } else {
          this.vadioArr[this.dqIndex - 1].player = new EZUIKit.EZUIKitPlayer({
            id: 'player' + this.dqIndex, // 视频容器ID
            accessToken: res.token,
            url: res.url,
            template: 'security',
            height: h,
            width: w,
            handleError: (err) => {
              if (err.type === 'handleRunTimeInfoError' && err.data.nErrorCode === 5) {
              // 加密设备密码错误
              }
            }
          })
          this.$set(this.vadioArr[this.dqIndex - 1], 'bfFlag', true)
          if (this.dqIndex < 4) {
            this.dqIndex++
          } else {
            this.dqIndex = 1
          }
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    gengxinFN () {
      this.dataList.forEach(itme => {
        let flag = this.vadioArr.some(g => g.id == itme.id)
        itme.flag = flag
      })
    },
    getListTree () {
      equipmentList({ tenantName: this.tenantName }).then(res => {
        this.dataList = res
      }).catch(error => {
        this.$message.error(error)
      })
    }
  },
  destroyed () {

  }
}
</script>
<style scoped lang='less'>
  .treeBigBox {
    width: 100%;
    height: calc(100vh - 42px - 35px - 42px - 10px);
    // margin-top: -12px;
    display: flex;
  }
  .treeBox {
    width: 20%;
    height: 100%;
    padding: 10px 0 0 20px;
  }
  .right {
    width: 80%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    border-left: solid 1px #ccc;
    background: #000;
  }
  .playerBox{
    width:49%;height: 50%;border: 1px solid #ddd;
    position: relative;
  }
  .active{
    border: 1px solid #2608cf;
  }
  .active1{
    color: #2608cf;
  }
  .tishiBox{
    color: #fff;
    text-align: center;
    position: absolute;
    width: 100%;
    top: 20vh;
     z-index: 99999
  }
  .delBox{
    background-color: #595959;
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    padding: 2px;
    position: absolute;
    right: 8px;
    text-align: center;
    top: 8px;
    width: 24px;
    z-index: 99999
  }
</style>
